import { render, staticRenderFns } from "./company_rebate.vue?vue&type=template&id=bf7bbfac&scoped=true"
import script from "./company_rebate.vue?vue&type=script&lang=js"
export * from "./company_rebate.vue?vue&type=script&lang=js"
import style0 from "./company_rebate.vue?vue&type=style&index=0&id=bf7bbfac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7bbfac",
  null
  
)

export default component.exports